<template>
  <img
    v-if="isEnabled"
    :src="trackingUrl"
    id="__tms_pc"
    height="1"
    width="1"
    alt=""
  />
</template>

<script>
import freshRelevanceConfig from "@/config/freshRelevance";

export default {
  name: "FreshRelevancePixel",
  props: {
    email: {
      type: String,
      required: true,
    },
    orderReference: {
      type: String,
      required: true,
    },
  },
  computed: {
    isEnabled() {
      return freshRelevanceConfig.enabled;
    },
    trackingUrl() {
      return `${freshRelevanceConfig.pixelUrl}/?e=${this.email}&r=${this.orderReference}`;
    },
  },
};
</script>

<style scoped>
img {
  display: inline-block;
}
</style>
